import { render, staticRenderFns } from "./MarketTrendsList.vue?vue&type=template&id=bdcdafb6&"
import script from "./MarketTrendsList.vue?vue&type=script&lang=js&"
export * from "./MarketTrendsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports